import React from "react";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useParams } from "react-router-dom";
import axios from "../../../helper/axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { patientregistration } from "../../../helper/schemas";
import { useToast } from "../../ToastSystem"; // Import Toast
import * as Yup from "yup";
import { useUser } from "../../../Provider";
import {
  TextField,
  Autocomplete,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Define validation schema using Yup
const ValidationSchema = Yup.object().shape({
  bedname: Yup.string().required("Bed name is required"),
  hospitalcode: Yup.string().required("Please select the hospitalcode"),
  bedgroupid: Yup.string().required("Please select the bed group name"),
  bedtypeid: Yup.string().required("Please select the bed type"),
});

const ValidationSchema1 = Yup.object().shape({
  bedname: Yup.string().required("Bed name is required"),
  bedgroupid: Yup.string().required("Please select the bed group name"),
  bedtypeid: Yup.string().required("Please select the bed type"),
});

const initialValues = {
  bedname: "",
  bedtypeid: "",
  bedgroupid: "",
  hospitalcode: "",
};

const EditBed = () => {
  const {
    user,
    userHospitalcode,
    userrole1,
    isAuthRole,
    isAuthorized,
    gettokenId,
    token,
  } = useUser();
  const { showSuccess, showError, showWarning, showInfo } = useToast(); // Toast hooks

  const history = useHistory();
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [openAutocompleted, setOpenAutocompleted] = useState(false);

  const { bedid } = useParams();

  const handleExpandClick = () => {
    setOpenAutocomplete(!openAutocomplete);
  };

  const handleExpandClicked = () => {
    setOpenAutocompleted(!openAutocompleted);
  };

  const getValidationSchema = () => {
    if (userHospitalcode === 1) {
      return ValidationSchema;
    } else {
      return ValidationSchema1;
    }
  };

  const {
    values,
    errors,
    touched,
    setValues,
    handleChange,
    handleBlur,
    resetForm,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: getValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        if (userHospitalcode !== undefined) {
          const data = new FormData();
          data.append("document", JSON.stringify(values));
          data.append("bedid", bedid);
          data.append("userHospitalcode", JSON.stringify(userHospitalcode));
          data.append("currentDateTime", JSON.stringify(getCurrentDateTime()));
          data.append("gettokenId", JSON.stringify(gettokenId));
          data.append("currentDate", JSON.stringify(currentDate));

          console.log(JSON.stringify(values));

          const response = await axios.post(`/BedUpdate/'${bedid}'`, data, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            params: {
              hospitalcode: userHospitalcode,
              userrole: userrole1,
            },
          });

          if (response.status === 200) {
            showSuccess("Bed updated successfully!");
            setTimeout(() => {
              history.push("/listviewbed");
            }, 1500);
          } else {
            console.error("Error updating bed");
            setSuccess(false);
            setError(true);
            showError("Failed to update bed. Please try again.");
          }
        }
      } catch (error) {
        console.error("Error:", error.message);
        setSuccess(false);
        setError(true);

        // Error handling with specific messages
        if (error.response) {
          if (error.response.status === 403) {
            showError("You don't have permission to update this bed.");
          } else if (error.response.status === 404) {
            showError("Bed not found. It may have been deleted.");
          } else if (error.response.status === 409) {
            showWarning(
              "Bed name already exists. Please use a different name."
            );
          } else if (error.response.status === 500) {
            showError("Server error. Please try again later.");
          } else {
            showError(error.response.data?.message || "Failed to update bed.");
          }
        } else if (error.request) {
          showError("Network error. Please check your connection.");
        } else {
          showError("Something went wrong. Please try again.");
        }
      }
    },
  });

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const currentDateTimeString = `${year}-${month}-${day}T${hours}:${minutes}`;
    return currentDateTimeString;
  };

  let Showdate = new Date();
  let ShowTodaydate =
    Showdate.getFullYear() +
    "-" +
    (Showdate.getMonth() + 1) +
    "-" +
    Showdate.getDate();
  const [currentDate, setCurrentDate] = useState(ShowTodaydate);

  const handleSearchChange = async (searchTerm) => {
    const selectedHospitalCode = searchTerm.hospitalcode || userHospitalcode;
    await fetchBedGroups(selectedHospitalCode);
    await fetchBedTypes(selectedHospitalCode);
  };

  const [data, setData] = useState([]);
  const [userRole, setRole] = useState();
  const [bedGroups, setBedGroups] = useState([]);
  const [bedTypes, setBedTypes] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      await loadHospitalcode();
      const selectedHospitalCode = values.hospitalcode || userHospitalcode;
      fetchBedTypes(selectedHospitalCode);
      fetchBedGroups(selectedHospitalCode);
    };
    loadData();
  }, [userHospitalcode, userrole1, isAuthorized, values.hospitalcode]);

  const loadHospitalcode = async () => {
    try {
      if (userHospitalcode !== undefined && userrole1 !== undefined) {
        const res = await axios.get("/gethospitalcode", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            hospitalcode: userHospitalcode,
            userrole: userrole1,
          },
        });
        setData(res.data);
        console.log(res.data);
      }
    } catch (error) {
      console.error("Error loading hospital codes:", error);
      showError("Failed to load hospital codes.");
    }
  };

  const fetchBedTypes = async (selectedHospitalCode) => {
    try {
      const response = await axios.get("/getbedtype", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          hospitalcode: selectedHospitalCode,
        },
      });

      if (response.status === 200) {
        setBedTypes(response.data);
      } else {
        console.error(
          `Failed to fetch bed types with status: ${response.status}`
        );
        showWarning("Failed to load bed types.");
      }
    } catch (error) {
      console.error("Error fetching bed types:", error.message);
      // showError("Error loading bed types.");
    }
  };

  const fetchBedGroups = async (selectedHospitalCode) => {
    try {
      const response = await axios.get("/getbedgroup", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          hospitalcode: selectedHospitalCode,
        },
      });

      if (response.status === 200) {
        setBedGroups(response.data);
      } else {
        console.error(
          `Failed to fetch bed groups with status: ${response.status}`
        );
        showWarning("Failed to load bed groups.");
      }
    } catch (error) {
      console.error("Error fetching bed groups:", error.message);
      // showError("Error loading bed groups.");
    }
  };

  const loadBed = async () => {
    setLoading(true);
    try {
      if (userHospitalcode !== undefined && userrole1 !== undefined) {
        const response = await axios.get(`/getbedbybedid/${bedid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            hospitalcode: userHospitalcode,
            userrole: userrole1,
          },
        });

        const beddata = response.data;
        console.log("Bed data:", beddata);
        setValues(beddata);
        // showSuccess("Bed details loaded successfully!");
      }
    } catch (error) {
      console.error("Error loading bed details:", error.message);

      if (error.response) {
        if (error.response.status === 404) {
          showError("Bed not found. It may have been deleted.");
          setTimeout(() => history.push("/listviewbed"), 2000);
        } else if (error.response.status === 403) {
          showError("You don't have permission to view this bed.");
        } else if (error.response.status === 500) {
          showError("Server error. Please try again later.");
        } else {
          showError("Failed to load bed details.");
        }
      } else if (error.request) {
        showError("Network error. Please check your connection.");
      } else {
        showError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await loadBed();
    };
    loadData();
  }, [userHospitalcode, userrole1, isAuthorized]);

  const currentDomain = window.location.hostname;

  return (
    <div className="p-3 pt-0 appointment">
      <Helmet>
        <title>
          Update Bed Details | {currentDomain} | Hospital Management Software |
          Smart Solutions for Hospital Efficiency
        </title>
      </Helmet>

      <form onSubmit={handleSubmit}>
        <div className="fill header">
          <h3 className="float-left">Bed Edit</h3>
        </div>

        {loading ? (
          <div className="text-center p-5">
            <p>Loading bed details...</p>
          </div>
        ) : (
          <div className="patient-new primary-info">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <div className="col-md-12 mt-3">
                      <div className="row">
                        <div className="col-md-4">
                          <label
                            htmlFor="bedname"
                            className="col-form-label leftone"
                          >
                            Bed Name
                          </label>
                        </div>
                        <div className="col-md-8">
                          <input
                            type="text"
                            autoComplete="off"
                            name="bedname"
                            id="bedname"
                            placeholder="Bed Name"
                            value={values.bedname}
                            onChange={handleChange}
                            className="form-control ember-text-field text-left ember-view"
                          />
                          {errors.bedname && touched.bedname ? (
                            <p className="form-erroremployee">
                              {errors.bedname}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="row">
                        <div className="col-md-4">
                          <label
                            htmlFor="groupname"
                            className="col-form-label leftone"
                          >
                            Bed Group Name
                          </label>
                        </div>
                        <div className="col-md-8">
                          <Autocomplete
                            freeSolo
                            id="free-solo"
                            options={bedGroups}
                            getOptionLabel={(bedGroup) => bedGroup.groupname}
                            value={
                              bedGroups.find(
                                (bedGroup) =>
                                  bedGroup.bedgroupid === values.bedgroupid
                              ) || null
                            }
                            open={openAutocomplete}
                            onOpen={() => setOpenAutocomplete(true)}
                            onClose={() => setOpenAutocomplete(false)}
                            onChange={(event, newValue) => {
                              setValues({
                                ...values,
                                bedgroupid: newValue ? newValue.bedgroupid : "",
                              });
                            }}
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select BedGroup"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={handleExpandClick}>
                                        <ExpandMoreIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                            renderOption={(props, option) => (
                              <li {...props}>
                                {option.groupname}-{option.floorname}
                              </li>
                            )}
                          />
                          {errors.bedgroupid && touched.bedgroupid ? (
                            <p className="form-erroremployee">
                              {errors.bedgroupid}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    {isAuthorized ? (
                      <div className="col-md-12 mt-3">
                        <div className="row">
                          <div className="col-md-4">
                            <label
                              htmlFor="hospitalcode"
                              className="col-form-label leftone"
                            >
                              Hospital Code
                            </label>
                          </div>
                          <div className="col-md-8">
                            {isAuthorized ? (
                              <input
                                type="text"
                                autoComplete="off"
                                name="hospitalcode"
                                id="hospitalcode"
                                placeholder="Hospital Code"
                                value={values.hospitalcode}
                                disabled={true}
                                className="form-control"
                              />
                            ) : (
                              <input
                                type="text"
                                name="hospitalcode"
                                id="hospitalcode"
                                value={userHospitalcode}
                                disabled={true}
                                className="form-control"
                              />
                            )}
                            {isAuthorized &&
                            errors.hospitalcode &&
                            touched.hospitalcode ? (
                              <p className="form-erroremployee">
                                {errors.hospitalcode}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="col-md-12 mt-3">
                      <div className="row">
                        <div className="col-md-4">
                          <label
                            htmlFor="bedtype"
                            className="col-form-label leftone"
                          >
                            Bed Type
                          </label>
                        </div>
                        <div className="col-md-8">
                          <Autocomplete
                            freeSolo
                            id="free-solo"
                            options={bedTypes}
                            getOptionLabel={(bedType) => bedType.bedtype}
                            value={
                              bedTypes.find(
                                (bedType) =>
                                  bedType.bedtypeid === values.bedtypeid
                              ) || null
                            }
                            open={openAutocompleted}
                            onOpen={() => setOpenAutocompleted(true)}
                            onClose={() => setOpenAutocompleted(false)}
                            onChange={(event, newValue) => {
                              setValues({
                                ...values,
                                bedtypeid: newValue ? newValue.bedtypeid : "",
                              });
                            }}
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select BedType"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton onClick={handleExpandClicked}>
                                        <ExpandMoreIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          />
                          {errors.bedtypeid && touched.bedtypeid ? (
                            <p className="form-erroremployee">
                              {errors.bedtypeid}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="modal-buttons">
          <Button
            type="submit"
            variant="success"
            className="mx-3"
            disabled={loading}
          >
            {loading ? "Updating..." : "Update"}
          </Button>
        </div>
      </form>
    </div>
  );
};
export default EditBed;
